import Config from './messages';

/**
 * Intercept resources that attempt to load data before a filter value is available
 *
 * @param resource
 * @param type
 * @param params
 *
 * @return boolean
 */
export const interceptLoadData = (type, resource, params) => {
    if (resource === 'SalesByDate' && type === 'GET_LIST') {
        if (!params.filter.sales_date_from || !params.filter.sales_date_to) {
            // @TODO remove if automatic loading by dates
            return true;
        }
    }
    return false;
};

/**
 * Create a payload object for upsert functions
 *
 * @param resource
 * @returns {{}|{payload: {}}}
 */
export const createPayload = (resource) => {

    if (resource === 'ScheduledReports') {
        return {
        };
    }

    // Create payload object
    let payloadObj = {
        "payload": {}
    };

    payloadObj.client = {
        device: Config.fuse.client.device,
        version: Config.fuse.admin.version
    };
    payloadObj.payload = {};

    return payloadObj;
};

/**
 * Customize a payload object for upsert functions
 *
 * @param type
 * @param resource
 * @param dataObj
 */
export const assignPayload = (type, resource, dataObj) => {
    let payload = {};

    // All resources populate the payload
    payload = dataObj;

    return payload;
};

/**
 * Pre-process submission data before posting
 *
 * @param resource
 * @param type
 * @param params
 * @returns {*}
 */
export const preProcessData = (resource, type, params) => {
    if (resource === 'ScheduledReports') {
        params = populateScheduledReportParams(params);
    }
    return params;
};

// Update Scheduled Report Edit
const populateScheduledReportParams = (params) => {

    // Convert Secondary arrays
    let filterType = params.data.filter_types;
    let filterChoice = params.data.filter_first_choice;
    params.data.payload.location.cities = (filterType === 'city') ? [filterChoice] : [];
    params.data.payload.location.dbas = (filterType === 'dba') ? [filterChoice] : [];
    params.data.payload.location.districts = (filterType === 'district') ? [filterChoice] : [];
    const locations = (params.data.payload && params.data.payload.location && params.data.payload.location.locations) ? params.data.payload.location.locations : [];
    if (filterType === 'location' && locations.length > 0) {
        params.data.payload.location.locations = [locations[0]];
    } else if (filterType === 'locations') {
        // Convert Location IDs to string
        for (let l = 0; l < locations.length; l++) {
            let location = params.data.payload.location.locations[l];
            params.data.payload.location.locations[l] = location.toString();
        }
    } else {
        params.data.payload.location.locations = [];
    }
    params.data.payload.location.states = (filterType === 'state') ? [filterChoice] : [];

    if (params.data.date_range_type === 'relative') {
        // Convert Days Back
        let daysBack = parseInt(params.data.back_num, 10);
        let backType = params.data.back_type;
        if (daysBack && daysBack > 0) {
            if (backType === 'weeks') {
                daysBack *= 7;
            }
            if (backType === 'months') {
                daysBack *= 30;
            }
            params.data.payload.dateRange.daysBack = daysBack;
        }
        params.data.payload.dateRange.fromDay = '';
        params.data.payload.dateRange.toDay = '';
    }
    if (params.data.date_range_type === 'specific') {
        // Convert Start/End dates
        params.data.payload.dateRange.fromDay = params.data.from_day;
        params.data.payload.dateRange.toDay = params.data.to_day;
        params.data.payload.dateRange.daysBack = 0;
    }

    params.data.run_time = params.data.run_time_hour + ':00';

    // Convert emails to array
    let emails = params.data.emails_str.split(',');
    for (let r = 0; r < emails.length; r++) {
        emails[r] = emails[r].trim();
    }
    params.data.emails = emails;

    delete params.data.date_range_type;
    delete params.data.from_day;
    delete params.data.to_day;
    delete params.data.filter_types;
    delete params.data.filter_first_choice;
    delete params.data.run_time_hour;
    delete params.data.back_num;
    delete params.data.back_type;
    delete params.data.emails_str;

    return params;
};



// WEBPACK FOOTER //
// ./src/Fuse/restClientPreProcess.js